import {
  BaseProfileDataInterface,
  CreateProfileInterface, NotificationsInterface, ProfileConfigInterface,
  ProfileInterface,
  ProfileRepositoryInterface,
} from '@/services/Users-profile/interfaces';
import { AxiosInstance } from 'axios';

export default class ProfileRepository implements ProfileRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async createProfile(profile: CreateProfileInterface): Promise<ProfileInterface> {
    const res = await this.axios.post('/employee-controller/profile', profile);

    return res.data;
  }

  public async getOneByUserId(userId: string): Promise<ProfileInterface> {
    const res = await this.axios.get(`/employee-controller/profile/user/${userId}`);

    return res.data;
  }

  public async updateProfile(userId: string, profileData: Partial<ProfileInterface>, image: File): Promise<void> {
    const formData = new FormData();
    formData.append('image', image);
    Object.keys(profileData).forEach((pd) => {
      formData.append(pd, JSON.stringify(profileData[pd]));
    });

    await this.axios.patch(`/employee-controller/profile/user/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  public async getBaseProfileDataByUserId(userId: string): Promise<BaseProfileDataInterface> {
    const res = await this.axios.get(`/employee-controller/profile/user/${userId}/base`);

    return res.data;
  }

  public async getBaseProfileDataByUsersIds(ids: string[]): Promise<BaseProfileDataInterface[]> {
    const res = await this.axios.post(`/employee-controller/profile/users-ids`, ids);

    return res.data;
  }

  public async updateProfileConfig(profileId: string, config: Partial<ProfileConfigInterface>): Promise<void> {
    await this.axios.patch(`/employee-controller/profile/${profileId}/config`, config);
  }

  public async getAllProfiles(page: number): Promise<[ProfileInterface[], number]> {
    const res = await this.axios.get(`/employee-controller/profile?page=${page}`);

    return res.data;
  }

  public async getProfileNotifications(): Promise<NotificationsInterface> {
    const res = await this.axios.get(`/employee-controller/notifications`,
      {
        params: { readLimit: 10 }
      });

    return res.data;
  }

  public async markNotificationAsRead(notificationId: string): Promise<void> {
    await this.axios.patch(`/employee-controller/notifications/${notificationId}`);
  }

  public async markAllNotificationsAsRead(): Promise<void> {
    await this.axios.patch(`/employee-controller/notifications/readAll`);
  }
}
